import { useDispatch, useSelector } from "react-redux";
import { SBAComboBox } from "../UiComponents/SBADropDown";
import { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { getRoles, getMenusToRole, deleteMenutoRole, insertUpdateMenuToRole, getAvailableMenus } from "../../config/apiConfig";
import { sbaAxios } from "../utils/sbaAxios";
import { useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';

export const MenuToRole = () => {
    const Gstate = useSelector((state) => state) || {};
    const [rolesData, setRolesData] = useState([]);
    const [selectedRole, setSelectedRole] = useState();
    const [MenuList, setMenuList] = useState([]);
    const [showDrawer, setShowDrawer] = useState(false);
    const MenuRef = useRef();
    const [Gridmenus, setGridMenus] = useState([]);
    const [render, setRender] = useState(true);
    const [allMenuList, setallMenuList] = useState([]);
    useEffect(() => {
        rolesListData();
        menuListData();
        if (selectedRole)
            getRolestouser();
    }, [render]);
    const roleDDchn = (e) => {
        setSelectedRole(e.value);
        sbaAxios({
            url: `${getMenusToRole}${e.value.RoleId}`,
            method: 'get',
        }).then(Response => { setMenuList(Response) }).catch(error => { console.log(error, 'error loadidng user list') });
    };
    const getRolestouser = () => {
        sbaAxios({
            url: `${getMenusToRole}${selectedRole.RoleId}`,
            method: 'get',
        }).then(Response => { setMenuList(Response) }).catch(error => { console.log(error, 'error loadidng user list') });
    }
    const menuListData = async () => {
        try {
            const response = await sbaAxios({
                url: `${getAvailableMenus}`,
                method: 'get',
            });
            const data = response;
            setallMenuList(data.map(item => (
                { ...item, addMenu: false }
            )))
        } catch (error) {
            console.error("Error fetching MenuListData from API:", error);
        }
    };
    const CheckboxRenderer = (props) => {
        const isAddded = props.data.addMenu;
        const UserData = props.data;
        return (
            <div className="actions-cell">
                <input type='checkbox' className="SBA_hand" checked={isAddded} onChange={(e) => {
                    setallMenuList(value => (value.map(item => {
                        if (item.MenuId === UserData.MenuId) {
                            return { ...item, 'addMenu': e.target.checked }
                        }
                        else {
                            return { ...item }
                        }
                    }
                    )))
                }} />
            </div>
        );
    }
    const assignMenu = () => {
        let menuAssigned = true;
        if (MenuRef.current) {
            const gridInstance = MenuRef.current.api;
            const allRowData = [];
            const duplicate = [];
            const savedata = [];
            gridInstance.forEachNode(node => {
                allRowData.push(node.data);
            });
            const filteredRow = (allRowData.filter(item => item.addMenu)).map(item => {
                return {
                    "RoleId": selectedRole.RoleId,
                    "RoleName": selectedRole.RoleName,
                    "MenuId": item.MenuId,
                    "MenuName": item.MenuName,
                    "UserId": selectedRole.UserId,
                    "UserName": selectedRole.UserName,
                    "CreatedBy": 38,
                    "ModifiedBy": 38,
                }
            });
            filteredRow.map(item => {
                if (MenuList.length != 0) {
                    MenuList.map(menuitem => {
                        if (item.MenuId === menuitem.MenuId) {
                            duplicate.push(menuitem.MenuName)
                        }
                        else {
                            savedata.push(item);

                        }
                    })
                }
                else {
                    savedata.push(item);
                }
            })
            console.log(savedata, "value");
            savedata.map(item => {
                sbaAxios({
                    url: `${insertUpdateMenuToRole}`,
                    method: 'post',
                    data: item,
                }).then(response => {
                    menuAssigned = true;
                })
            })
        };

        setShowDrawer(false);
        setRender(!render);
        if (menuAssigned) {
            toast.success("Menu Assigned to Role", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
        setTimeout(() => {
            getRolestouser();
        }, 1000);
    }


    const rolesListData = async () => {
        try {
            const response = await sbaAxios({
                url: `${getRoles}`,
                method: 'get',
            });
            const data = response;
            setRolesData(data);
        } catch (error) {
            console.error("Error fetching rolesListData from API:", error);
        }
    };

    const handleDeleteClick = (MenuId, RoleId, Menuname) => {
        sbaAxios({
            url: `${deleteMenutoRole}${RoleId},${MenuId}`,
            method: 'get',
        }).then(() => {
            toast.success(`${Menuname} Deleted From the Menu`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }).catch(() => {
            toast.error("Error Occured while Operation", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        })
        setRender(!render);
    };

    const DeleteButtonRenderer = (props) => {
        const MenuId = props.data.MenuId;
        const RoleId = props.data.RoleId;
        const Menuname = props.data.MenuName;

        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={() => handleDeleteClick(MenuId, RoleId, Menuname)}
                ></i>
            </div>
        );
    };


    const menuColDef = [
        {
            headerName: '',
            field: 'addMenu',
            cellRenderer: CheckboxRenderer,
            maxWidth: 80
        },
        {
            headerName: "Menu Name", field: "MenuName", filter: "agTextColumnFilter"
        },
    ];
    const MenuGridDef = [
        {
            headerName: "Menu Name", field: "MenuName"
        },
        { headerName: "Role Name", field: "RoleName" },

        {
            headerName: "Delete",
            field: "Delete",
            maxWidth: 100,
            cellRenderer: DeleteButtonRenderer,
        },
    ];
    const defaultColDef = {
        sortable: false,
        filter: false,
        suppressMovable: true,
        flex: 1,
        resizable:true
    };

    const AddMenu = () => {
        setShowDrawer(true);
    }
    return <>
        <div className="col-lg-4 mt-4">
            <label
                htmlFor="select-fund"
                className="mb-1 ms-2 fw-semibold fs-12"
            >
                Select Role
            </label>
            <SBAComboBox data={rolesData} value={selectedRole} onChange={roleDDchn} textField='RoleName' valueField='RoleId' />
        </div>
        <div className="row flex-wrap mt-4">
            {selectedRole && <div className="col-lg-6">
                <div className="header-container m-2 fs-12">
                    <b>Available Menu in {selectedRole.RoleName}</b>
                    <button className="p-sm-btn mx-1" onClick={AddMenu}>
                        <i className="fa-solid fa-plus" /> Add
                    </button>
                </div>
                <div className="ag-theme-alpine m-1 " style={{ height: 450 }}>
                    <AgGridReact
                        columnDefs={MenuGridDef}
                        rowData={MenuList}
                        defaultColDef={defaultColDef}
                    />
                </div>
            </div>}
        </div>
        <SBADrawer
            open={showDrawer}
            setOpen={setShowDrawer}
            close={false}
            title={`Update Menu for ${selectedRole?.RoleName}`}
            size={'lg'}
        >
            <div style={{ height: "80%" }}>
                <label className="header-container m-1">
                    <b>Menu Name</b>
                </label>
                <div className="ag-theme-alpine m-1 "  >
                    <AgGridReact
                        columnDefs={menuColDef}
                        rowData={allMenuList}
                        defaultColDef={defaultColDef}
                        ref={MenuRef}
                        suppressScrollOnNewData={true}
                    />
                </div>
                <div className="mt-4">
                    <button className="s-sm-btn mx-1" onClick={() => setShowDrawer(false)}>
                        Cancel
                    </button>
                    <button className="p-sm-btn mx-1" onClick={assignMenu}>
                        Assign Menu
                    </button>
                </div>
            </div>
        </SBADrawer>
    </>
}